import { ConfirmDeleteDialog } from '@/components/ConfirmDeleteDialog';

interface DeleteThreadDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => Promise<void> | void;
}

export function DeleteThreadDialog(props: DeleteThreadDialogProps) {
    return (
        <ConfirmDeleteDialog
            {...props}
            title="Delete thread"
            description="This action cannot be undone. This will permanently delete the thread and all its messages."
        />
    );
}
